"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _chart = _interopRequireDefault(require("@amzn/meridian-tokens/component/chart"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _victory = require("victory");

var _theme = require("../theme");

var _token = require("./../_utils/token");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Options for the useVictoryTheme hook
 *
 * @name victoryThemeOptions
 * @typedef victoryThemeOptions
 * @type {object}
 * @property {boolean} [showIndependentGrid=true] - This determines whether the
 *   independent grid is shown (the vertical "x" grid lines).
 * @property {boolean} [showDependentGrid=true] - This determines whether the
 *   dependent grid is shown (the horizontal "y" grid lines).
 * @property {("v100"|"v200"|"v300")} [tickLabelSize="v300"] - Set the size of
 *   the "tick" labels that mark values along each axis.
 * @property {("regular"|"bold")} [tickLabelWeight="regular"] - Set the weight
 *   of the "tick" labels that mark values along each axis.
 * @property {("v100"|"v200"|"v300")} [axisLabelSize="v300"] - Set the size of
 *   the "axis" labels that describe the x and y axis.
 * @property {("regular"|"bold")} [axisLabelWeight="bold"] - Set the weight
 *   of the "axis" labels that describe the x and y axis.
 * @property {number} [lineStrokeWidth=3] - Set the width in pixels of lines in
 *   a line chart.
 * @property {("basis"|"bundle"|"cardinal"|"catmullRom"|"linear"|"monotoneX"
 *   |"monotoneY"|"natural"|"step"|"stepAfter"|"stepBefore")} [interpolation="catmullRom"]
 *   - Sets the interpolation of a line chart. See the
 *   {@link https://formidable.com/open-source/victory/gallery/interpolation/|Victory
 *   documentation on interpolation for more details}.
 * @property {("primary"|"secondary"|"alternatePrimary"|"alternateSecondary"|"inverted")} [border]
 * - This determines whether borders are shown around the chart
 */

/**
 * This hook returns a Meridian-ized theme object for [Victory
 * charts](https://formidable.com/open-source/victory/). Pass the output of this
 * hook to the `theme` prop of the
 * [VictoryChart](https://formidable.com/open-source/victory/docs/victory-chart)
 * component.
 *
 * @param {victoryThemeOptions} [options={}] - Options to customize the theme.
 *
 * @returns {object} - The Victory theme object.
 */
var useVictoryTheme = function useVictoryTheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$showIndependentG = _ref.showIndependentGrid,
      showIndependentGrid = _ref$showIndependentG === void 0 ? true : _ref$showIndependentG,
      _ref$showDependentGri = _ref.showDependentGrid,
      showDependentGrid = _ref$showDependentGri === void 0 ? true : _ref$showDependentGri,
      _ref$tickLabelSize = _ref.tickLabelSize,
      tickLabelSize = _ref$tickLabelSize === void 0 ? "v300" : _ref$tickLabelSize,
      _ref$tickLabelWeight = _ref.tickLabelWeight,
      tickLabelWeight = _ref$tickLabelWeight === void 0 ? "regular" : _ref$tickLabelWeight,
      _ref$axisLabelSize = _ref.axisLabelSize,
      axisLabelSize = _ref$axisLabelSize === void 0 ? "v300" : _ref$axisLabelSize,
      _ref$axisLabelWeight = _ref.axisLabelWeight,
      axisLabelWeight = _ref$axisLabelWeight === void 0 ? "bold" : _ref$axisLabelWeight,
      _ref$lineStrokeWidth = _ref.lineStrokeWidth,
      lineStrokeWidth = _ref$lineStrokeWidth === void 0 ? 3 : _ref$lineStrokeWidth,
      _ref$interpolation = _ref.interpolation,
      interpolation = _ref$interpolation === void 0 ? "catmullRom" : _ref$interpolation,
      border = _ref.border;

  var t = (0, _theme.useTheme)(_chart["default"], "chart");
  var theme = {};
  var commonLabelStyles = {
    fill: t("foregroundColor"),
    fontFamily: t("labelFontFamily")
  };
  /**
   * Background
   */

  theme.chart = {
    background: {
      fill: t("backgroundColor")
    }
  };
  /**
   * Grid and axis styles
   */

  var axisLabel = _objectSpread(_objectSpread({}, commonLabelStyles), {}, {
    // HACK: Victory doesn't take the presence of tick labels into account when
    // positioning the axis label so we have to artificially inflate this
    // padding to keep the axis label from running into the tick labels.
    padding: t("labelSpacing") * 4,
    fontSize: t("labelFontSize", axisLabelSize),
    fontWeight: t("labelFontWeight", axisLabelWeight)
  });

  var tickLabels = _objectSpread(_objectSpread({}, commonLabelStyles), {}, {
    padding: t("labelSpacing"),
    fontSize: t("labelFontSize", tickLabelSize),
    fontWeight: t("labelFontWeight", tickLabelWeight)
  });

  theme.dependentAxis = {
    style: {
      axisLabel: axisLabel,
      tickLabels: tickLabels,
      grid: {
        stroke: showDependentGrid && t("gridBorderColor"),
        strokeWidth: t("gridBorderWidth")
      },
      axis: {
        stroke: showIndependentGrid && t("axisBorderColor"),
        strokeWidth: t("axisBorderWidth")
      }
    }
  };
  theme.independentAxis = {
    style: {
      axisLabel: axisLabel,
      tickLabels: tickLabels,
      grid: {
        stroke: showIndependentGrid && t("gridBorderColor"),
        strokeWidth: t("gridBorderWidth")
      },
      axis: {
        stroke: showDependentGrid && t("axisBorderColor"),
        strokeWidth: t("axisBorderWidth")
      }
    }
  };
  /**
   * Bar styles
   */

  theme.bar = {
    cornerRadius: t("barBorderRadius"),
    style: border ? {
      data: {
        stroke: (0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]),
        strokeWidth: t("borderWidth")
      }
    } : {}
  };
  /**
   * Line styles
   */

  theme.line = {
    interpolation: interpolation,
    style: {
      data: border ? {
        strokeWidth: lineStrokeWidth,
        filter: "drop-shadow(".concat(t("borderWidth"), "px 0 0 ").concat((0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]), ") drop-shadow(-").concat(t("borderWidth"), "px 0 0 ").concat((0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]), ") drop-shadow(0 -").concat(t("borderWidth"), "px 0 ").concat((0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]), ") drop-shadow(0 ").concat(t("borderWidth"), "px 0 ").concat((0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]), ")")
      } : {
        strokeWidth: lineStrokeWidth
      }
    },
    domainPadding: {
      y: lineStrokeWidth * 2
    }
  };
  /**
   * Scatter styles
   */
  // This needs to match the line domain padding so that scatter points overlaid
  // on lines match up correctly.

  theme.scatter = {
    domainPadding: theme.line.domainPadding,
    style: border ? {
      data: {
        stroke: (0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]),
        strokeWidth: t("borderWidth")
      }
    } : {}
  };
  return (0, _merge["default"])({}, _victory.VictoryTheme.grayscale, theme);
};

var _default = useVictoryTheme;
exports["default"] = _default;